export default __webpack_public_path__ + "static/media/034-ahead.58e48a36.png";